import Moment from "moment";

export default class FechasHelper {

    /**
     * @param date
     * @returns {boolean}
     */
    static isToday(date) {
        let fechaMoment = Moment(date, "YYYY-MM-DD HH:mm:ss");
        let nowMoment = Moment();

        if (!fechaMoment.isValid()) return false;

        return fechaMoment.year() === nowMoment.year() && fechaMoment.dayOfYear() === nowMoment.dayOfYear();
    }

    /**
     * @param date
     * @returns {boolean}
     */
    static isYesterday(date) {
        let fechaMoment = Moment(date, "YYYY-MM-DD HH:mm:ss");
        let nowMoment = Moment();

        if (!fechaMoment.isValid()) return false;

        return fechaMoment.year() === nowMoment.year() && fechaMoment.dayOfYear() === nowMoment.dayOfYear() - 1;
    }

    /**
     * @param date
     * @returns {boolean}
     */
    static isThisYear(date) {
        let fechaMoment = Moment(date, "YYYY-MM-DD HH:mm:ss");
        let nowMoment = Moment();

        if (!fechaMoment.isValid()) return false;

        return fechaMoment.year() === nowMoment.year();
    }

    /**
     * @param date
     * @returns string
     */
    static extractDate(date) {
        let fechaMoment = Moment(date, "YYYY-MM-DD HH:mm:ss");

        if (!fechaMoment.isValid()) return false;

        return fechaMoment.format("YYYY-MM-DD");
    }

    /**
     * @param date
     * @returns string
     */
    static onlyDate(date) {
        let fechaMoment = Moment(date, "YYYY-MM-DD HH:mm:ss");

        if (!fechaMoment.isValid()) return false;

        return fechaMoment.format("DD/MM/YYYY");
    }

    /**
     * @param date
     * @returns string
     */
    static onlyDayMonth(date) {
        let fechaMoment = Moment(date, "YYYY-MM-DD HH:mm:ss");

        if (!fechaMoment.isValid()) return false;

        return fechaMoment.format("DD/MM");
    }

    /**
     * @param date
     * @returns string
     */
    static onlyHour(date) {
        let fechaMoment = Moment(date, "YYYY-MM-DD HH:mm:ss");

        if (!fechaMoment.isValid()) return false;

        return fechaMoment.format("HH:mm");
    }

    /**
     * @param date
     * @returns string
     */
    static fullDate(date) {
        let fechaMoment = Moment(date, "YYYY-MM-DD HH:mm:ss");

        if (!fechaMoment.isValid()) return false;

        return fechaMoment.format("DD/MM/YYYY HH:mm:ss");
    }

    static hasHour(date) {
        return date.split(" ").length > 0
    }

    static copyObject(object) {
        return JSON.parse(JSON.stringify(object));
    }

    static convertStringToDate(date) {
        let fechaMoment = Moment(date, "YYYY-MM-DD HH:mm:ss");
        return fechaMoment.toDate();
    }

    static lt(date, secondDate) {
        let dateMoment = Moment(date, "YYYY-MM-DD HH:mm:ss");
        let secondDateMoment = Moment(secondDate, "YYYY-MM-DD HH:mm:ss");

        return dateMoment.isBefore(secondDateMoment);
    }

    static isSameDay(date, secondDate) {
        let dateMoment = Moment(date, "YYYY-MM-DD HH:mm:ss");
        let secondDateMoment = Moment(secondDate, "YYYY-MM-DD HH:mm:ss");

        return dateMoment.diff(secondDateMoment, 'days') === 0;
    }

    static primerDiaDelMesActual() {
        return Moment().startOf('month').format('YYYY-MM-DD');
    }

    static ultimoDiaDelMesActual() {
        return Moment().endOf('month').format('YYYY-MM-DD');
    }

    static ultimoDiaDelMes(dia) {
        let dateMoment = Moment(dia, "YYYY-MM-DD");
        return dateMoment.endOf('month').format('YYYY-MM-DD');
    }

    static diaRestarMes(dia) {
        let dateMoment = Moment(dia, "YYYY-MM-DD");
        return dateMoment.subtract(1, 'months').format('YYYY-MM-DD');
    }

    static diaSumarMes(dia) {
        let dateMoment = Moment(dia, "YYYY-MM-DD");
        return dateMoment.add(1, 'months').format('YYYY-MM-DD');
    }

    static ahoraSoloFecha() {
        return Moment().format('YYYY-MM-DD');
    }

    static diaSumarDias(dia, diasASumar) {
        let dateMoment = Moment(dia, "YYYY-MM-DD");
        return dateMoment.add(diasASumar, 'days').format('YYYY-MM-DD');
    }

    static year(dia) {
        let dateMoment = typeof dia !== "undefined" ? Moment(dia, "YYYY-MM-DD") : Moment();
        return dateMoment.format('YYYY');
    }
}